import React, { useEffect, useState } from "react";
import Thumbnail from "../Thumbnail";
import { StyledThumbnailContainer } from "./styled";
import { ThumbnailProps } from "../../types/ThumbnailProps";
import { Grid } from "@mui/material";

const ThumbnailList = (props: any) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (props?.items?.length) setItems(props.items);
  }, [props.items]);
  return (
    <StyledThumbnailContainer>
      <Grid container spacing={{ xs: 2, md: 3, lg: 3 }}>
        {items.map((item: ThumbnailProps) => (
          <Grid item xs={12} sm={12} md={4} lg={4} key={`thumbnail-grid-${item.videoIndexId}`}>
            <Thumbnail
              key={`thumbnail-${item.videoIndexId}`}
              {...item}
              onClickPlay={props.onClickPlay}
              onDownload={props.onDownload}
              onClickDetails={props.onClickDetails}
              onCopyLinks={props.onCopyLinks}
              onClickEdit={props.onClickEdit}
              onClickRetag={props.onClickRetag}
              onClickMove={props.onClickMove}
              onUnassignVertical={props.onUnassignVertical}
              isBrowseOnly={props.isBrowseOnly}
            />
          </Grid>
        ))}
      </Grid>
    </StyledThumbnailContainer>
  );
};

export default ThumbnailList;
